import React, { useEffect, useState } from "react";
import { db } from "../firebaseConfig.js";
import { collection, updateDoc, doc, getDocs } from "firebase/firestore";

const GamificationSystem = ({ staff }) => {
  const [staffWithPoints, setStaffWithPoints] = useState([]);

  useEffect(() => {
    // Asegurarse de que todos los empleados tengan un valor numérico en "points"
    const updatedStaff = staff.map((employee) => ({
      ...employee,
      points: Number(employee.points) || 0, // Si no tiene puntos, inicializar en 0
    }));

    setStaffWithPoints(updatedStaff.sort((a, b) => b.points - a.points));
  }, [staff]);

  const handleAddPoints = async (id, points) => {
    const employeeIndex = staffWithPoints.findIndex((emp) => emp.id === id);
    if (employeeIndex === -1) return;

    const updatedPoints = (staffWithPoints[employeeIndex].points || 0) + points;
    const updatedStaff = [...staffWithPoints];
    updatedStaff[employeeIndex] = { ...updatedStaff[employeeIndex], points: updatedPoints };
    
    setStaffWithPoints(updatedStaff);

    try {
      const staffRef = doc(db, "staff", id);
      await updateDoc(staffRef, { points: updatedPoints });
    } catch (error) {
      console.error("Error al actualizar los puntos:", error);
    }
  };

  return (
    <div>
      <h3>Sistema de Gamificación</h3>
      <table className="table">
        <thead>
          <tr>
            <th>Nombre</th>
            <th>Puntos</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {staffWithPoints.map((employee) => (
            <tr key={employee.id}>
              <td>{employee.name}</td>
              <td>{employee.points}</td>
              <td>
                <button className="btn btn-success" onClick={() => handleAddPoints(employee.id, 10)}>
                  +10 Puntos
                </button>
                <button className="btn btn-primary" onClick={() => handleAddPoints(employee.id, 50)}>
                  +50 Puntos
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default GamificationSystem;
